import { Component, Input } from '@angular/core';
import { BaseSelectorComponent } from '../BaseSelectorComponent.js';
import { HierarchicalMenuOption, MenuOption } from '../../../services/index.js';

@Component({
	selector: 'simple-selector',
	templateUrl: './simple-selector.component.html',
	styleUrls: ['../base-selector.scss'],
	standalone: false,
})
export class SimpleSelectorComponent<T> extends BaseSelectorComponent<T> {
	@Input()
	public label: string = 'Select';
	@Input()
	public class: string = 'dropdown';

	@Input()
	public enableFilter: boolean = false;

	public get filteredOptions():
		| MenuOption<T>[]
		| HierarchicalMenuOption<T>[] {
		return this.menuOptions.filter(
			(opt) =>
				!this.enableFilter ||
				opt.label.toLowerCase().includes(this.searchText)
		);
	}

	public searchText: string = '';

	onSearchChange(event) {
		this.searchText = event.target.value?.toLowerCase();
	}

	@Input()
	public placeholderText: string = 'Type to filter...';
}
